import script from "./AppsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppsButton.vue?vue&type=script&setup=true&lang=ts"

import "./AppsButton.vue?vue&type=style&index=0&id=42fa8f62&scoped=true&lang=scss"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fa8f62"]])

export default __exports__